'use strict';

const promoCode = {
    elements: {
        $cartWrapper: $('.js-cart'),
        $checkoutWrapper: $('.js-checkout'),
        $orderSummaryTotal: $('.js-orderSummary-total'),
        $paymentCartTotal: $('.js-payment-cart-total'),
        $totalOrderValue: $('.js-cart-totals-value'),
        $cartTotalsTaxValue: $('.js-cart-totals-tax-value'),
        $cartTotalsValue: $('.js-cart-totals-value'),
        $cartSubTotalsValue: $('.js-cart-sub-totals-value'),
        $shippingCost: $('.js-shipping-cost')
    },

    state: {
        firstRender: false,
        isOpen: false
    },

    selectors: {
        promoCode: '#promoCode',
        promoCodeWrapper: '#js-promo-code',
        promoCodeToggle: '.js-promo-code-toggle',
        promoCodeForm: '.js-promo-code-form',
        inputPromoCode: '#couponCode',
        clearBtn: '.js-promo-code-clear',
        submitBtn: '.js-promo-code-submit',
        btnRemovePromoCode: '.js-remove-coupon',
        discountsContainer: '.js-coupons-promos',
        errorWrapper: '.js-promo-code-error',
        errorMessage: '.js-promo-error-msg',
        checkoutDiscountContainer: '.js-checkout-discount',
        checkoutDiscountValue: '.js-checkout-discount-value',
        ordersummaryList: '.js-ordersummary-list',
    },

    renderPromoCode(cart) {
        const { promoCodeWrapper, discountsContainer } = this.selectors;

        $(promoCodeWrapper).morphBy({
            id: this.selectors.promoCode,
            squirrellyOptions: {
                actionUrls: cart.actionUrls,
                totals: cart.totals,
                isOpen: this.state.isOpen,
                csrf: {
                    tokenName: cart.csrf?.tokenName,
                    token: cart.csrf?.token
                }
            },
            morphDomOptions: { morph: true, childrenOnly: true }
        });

        if (!this.state.firstRender) {
            this.bindPromoCodeEvents();
            this.state.firstRender = true;

            // Updates discount list on initial render
            $(discountsContainer).html(cart.totals.discountsHtml);

            // Updates discount list after cart changes
            this.elements.$cartWrapper.on('cart-update', (e, data) => {
                $(discountsContainer).html(data.totals.discountsHtml);
            });
        }
    },

    checkoutRenderPromoCode() {
        const { discountsContainer } = this.selectors;

        if (!this.state.firstRender) {
            this.bindPromoCodeEvents();
            this.state.firstRender = true;

            // Updates discount list after checkout total changes
            this.elements.$checkoutWrapper.on('cart-update', (e, data) => {
                var isFREEvalue = data.totals.subtotalvalue - data.totals.orderLevelDiscountTotal.value >= data.totals.offeredShippingMethodthreshold;
                let shippingModel = data.shipments[0].shippingMethods[0];
                var isFreeShipping = (isFREEvalue && shippingModel.ID == data.totals.offeredShippingMethod)  || shippingModel.isFreeShipping;
                $(discountsContainer).html(data.totals.discountsHtml);
                this.elements.$orderSummaryTotal.text(data.totals.grandTotal);
                this.elements.$paymentCartTotal.text(data.totals.grandTotal);
                this.elements.$totalOrderValue.text(data.totals.grandTotal);
                if(data.totals.orderLevelDiscountTotal.value){
                    $(this.selectors.checkoutDiscountContainer).removeClass('d-none');
                    $(this.selectors.checkoutDiscountValue).text('-' + data.totals.orderLevelDiscountTotal.formatted);
                }else{
                    $(this.selectors.checkoutDiscountContainer).addClass('d-none');
                    $(this.selectors.checkoutDiscountValue).text('-' + data.totals.orderLevelDiscountTotal.formatted);
                }
                this.elements.$cartSubTotalsValue.text(data.totals.subTotal);
                this.elements.$cartTotalsTaxValue.text(data.totals.totalTax);
                this.elements.$shippingCost.text(isFreeShipping ? data.resources.freeShippingCostLabel : data.totals.totalShippingCost);
            });
        }
    },

    bindPromoCodeEvents() {
        const $selectedWrapper = this.elements.$cartWrapper.length ? this.elements.$cartWrapper : this.elements.$checkoutWrapper;
        const { promoCodeToggle, inputPromoCode, promoCodeForm, btnRemovePromoCode, clearBtn } = this.selectors;

        // Toggles promo code form open/close
        $(promoCodeToggle).on('click.promoCodeToggleHandler', this.openFormPromoCode.bind(this));

        // Toggles submit/clear button when user types
        $selectedWrapper.on('input.inputPromoCodeHandler', inputPromoCode, this.onKeyPressFieldPromoCode.bind(this));

        // Handles promo code form submission
        $selectedWrapper.on('submit.promoCodeFormHandler', promoCodeForm, this.onSubmitPromoCode.bind(this));

        // Removes applied promo code
        $selectedWrapper.on('click.btnRemovePromoCodeHandler', btnRemovePromoCode, this.onRemovePromoCode.bind(this));

        // Clears promo code input field
        $selectedWrapper.on('click.clearBtnHandler', clearBtn, this.onClearFieldPromoCode.bind(this));
    },

    openFormPromoCode(e) {
        const button = $(e.currentTarget);
        const wrapper = button.closest(this.selectors.promoCodeWrapper);

        const isOpen = button.data('open') === true;

        wrapper.toggleClass('is-open', !isOpen);
        button.attr('aria-expanded', String(!isOpen));
        button.data('open', !isOpen);

        this.state.isOpen = !isOpen;
    },

    onKeyPressFieldPromoCode(e) {
        const input = $(e.currentTarget);
        const wrapper = input.closest(this.selectors.promoCodeWrapper);
        const submitBtn = wrapper.find(this.selectors.submitBtn);

        const hasValue = !!input.val().trim().length;

        // Shows submit button only when input has text
        submitBtn.toggleClass('hidden', !hasValue);
    },

    onClearFieldPromoCode(e) {
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(this.selectors.promoCodeWrapper);

        const $input = $wrapper.find(this.selectors.inputPromoCode);
        const $submitBtn = $wrapper.find(this.selectors.submitBtn);
        const $clearBtn = $wrapper.find(this.selectors.clearBtn);
        const $errorWrapper = $wrapper.find(this.selectors.errorWrapper);
        const $errorMessage = $wrapper.find(this.selectors.errorMessage);

        if ($input.length) $input.val('');
        $input.removeClass('valid');
        if ($submitBtn.length) $submitBtn.addClass('hidden');
        if ($clearBtn.length) $clearBtn.addClass('hidden');
        if ($errorWrapper.length) $errorWrapper.addClass('hidden');
        if ($errorMessage.length) $errorMessage.empty();
    },

    onSubmitPromoCode(e) {
        e.preventDefault();
        
        const $form = $(e.currentTarget);
        const { clearBtn, submitBtn, errorWrapper, errorMessage, discountsContainer, inputPromoCode } = this.selectors;
        const promoValue = $form.find(inputPromoCode).val();

        $form.find(clearBtn).removeClass('hidden');
        $form.find(submitBtn).addClass('hidden');
        $form.find(inputPromoCode).addClass('valid');
        if ($(this.selectors.ordersummaryList).length) {
            $form.find('.isAppliedCouponFromCheckout').val('true');
        }
        $.spinner().start();
        $.ajax({
            url: $form.attr('action'),
            method: 'GET',
            data: $form.serialize(),
            success: (data) => {
                if (data.error) {
                    $(errorWrapper).removeClass('hidden');
                    $(errorMessage).empty().text(data.errorMessage);
                } else {
                    if(this.elements.$cartWrapper.length) {
                        // Updates displayed discount section after applying promo
                        $(discountsContainer).html(data.totals.discountsHtml);
                        this.elements.$cartWrapper.trigger('cart-update', data);
                    }
                    if(this.elements.$checkoutWrapper.length) 
                    {
                        this.elements.$checkoutWrapper.trigger('cart-update', data);
                    }
                    if ($(this.selectors.ordersummaryList).length && data.cartItemsHtml) {
                        $(this.selectors.ordersummaryList).html(data.cartItemsHtml);
                    }
                    // Ensures clear button remains visible after applying code
                    $form.find(clearBtn).removeClass('hidden');

                    // Keeps input marked as valid
                    $form.find(inputPromoCode).addClass('valid');

                    // Restores entered promo value
                    $form.find(inputPromoCode).val(promoValue);

                    // Hides error wrapper if promo applied successfully
                    $(errorWrapper).addClass('hidden');

                    // Clears any previous error messages
                    $(errorMessage).empty();
                    if (window.dataLayer && data.checkoutOrderData) {
                        window.dataLayer.push(data.checkoutOrderData);
                    }
                    $.spinner().stop();
                }
            }
        });
    },

    onRemovePromoCode(e) {
        const btn = $(e.currentTarget);
        const url = btn.data('action');
        const uuid = btn.data('uuid');
        const couponCode = btn.attr('data-code');
        const { promoCodeForm } = this.selectors;
        if ($(this.selectors.ordersummaryList).length) {
            $(promoCodeForm).find('.isAppliedCouponFromCheckout').val('true');
        }
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                code: couponCode,
                uuid: uuid,
                isAppliedCouponFromCheckout: $(promoCodeForm).find('.isAppliedCouponFromCheckout').val()
            },
            success: (data) => {
                $('.coupon-uuid-' + uuid).remove();
                if (this.elements.$cartWrapper.length) {
                    this.elements.$cartWrapper.trigger('cart-update', data);
                }
                else if(this.elements.$checkoutWrapper.length) {
                    this.elements.$checkoutWrapper.trigger('cart-update', data);
                }
                if ($(this.selectors.ordersummaryList).length && data.cartItemsHtml) {
                    $(this.selectors.ordersummaryList).html(data.cartItemsHtml);
                }
                if (window.dataLayer && data.checkoutOrderData) {
                    window.dataLayer.push(data.checkoutOrderData);
                }
                $.spinner().stop();
            }
        });
    }
};

module.exports = {
    renderPromoCode: (cart) => promoCode.renderPromoCode(cart),
    checkoutRenderPromoCode: (checkout) => promoCode.checkoutRenderPromoCode(checkout)
};